import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.BACKGROUND.DEFAULT};
  height: 100%;
`;
